import Container from 'react-bootstrap/Container';
import { Alert, Button, Card, Table, Modal, Accordion } from 'react-bootstrap';
import {Sida,Rubrik,ContentWrapper,Stycke,StyckeCompact} from "../ContentStyles";
import useBackend, {XLogOff, IsLoggedIn,Loading, Check, CallAPI, CallAPIGet} from '../../services/useBackend';
import {MaterialReactTable} from 'material-react-table';
import React, { useState ,useEffect, useReducer, fetchData,useMemo} from 'react';
import {DateTimeToLocal, MultiselectGetOptions, MultiselectGetDefaultValues, escapedNewLineToLineBreakTag, ConcatLocalDateAndTime2ISO, SplitoutLocalDateFromISO, SplitoutLocalTimeFromISO, getOptions, metaLookUpTitle, metaLookUpAccountTitle} from '../../services/misc';

function Accounts() {  
  const {loading:loadingmeta, data:metadata} =  useBackend(process.env.PUBLIC_URL+'/api/meta');    

  const columns = useMemo(() => [    
    { size: 40, accessorKey: 'Identifier',   header: 'Konto', enableColumnActions: false },
    { size: 40, accessorKey: 'Description',   header: 'Beskrivning', enableColumnActions: false },        
    ]
  );

  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 50 });

  const initialState = { density: 'compact', columnVisibility: { } };      

  const state = { pagination };     

  if (!loadingmeta) {
    return (
      <ContentWrapper>
        <Sida>
          <MaterialReactTable columns={columns} data={metadata.BookKeepingAccounts} state={state} initialState={initialState}
              muiTablePaginationProps={{ showFirstButton: false, showLastButton: false, rowsPerPageOptions: [25, 50, 75, 100] ,labelRowsPerPage:"Rader"}}

              renderTopToolbarCustomActions={() => (<span>Kontoplan</span>)}                      
              
              muiTablePaperProps={{elevation: 0, sx: {borderRadius: '0',border: '0px dashed #e0e0e0'} }} 
          />                                             
        </Sida>
      </ContentWrapper>        
    );
  } else {
      return (<Loading />);        
  }    
}

export default Accounts;